import React from 'react';
import { observer } from '@poa/state';

function getPosition(position) {
  if (position === 'right') {
    return { right: '-30px' };
  }

  if (position === 'left') {
    return { left: '-30px' };
  }

  return {};
}

export const DataTableCounter = observer(
  ({ headersInViewPort, onScrollTableTo, data, position }) => {
    if (headersInViewPort.get()) {
      return (
        <div onClick={onScrollTableTo} style={getPosition(position)} className="table-counter">
          +{headersInViewPort.get()}
        </div>
      );
    }

    return null;
  }
);
